import React from 'react';
import { connect } from 'tanok';
import {
    BESIDA_ROLE_BUYER
} from '@evo/chat-core';

import { toJS } from '../../../../../helpers/ImmutableToJS';

import { ClientBan } from './client';
import { CompanyBan } from './company';

// styles
import css from './banNotification.sss';

const BanNotificationView = ({ userRole }) => {
    const isInBuyerRole = userRole === BESIDA_ROLE_BUYER;

    return (
        <div className={css.root}>
            {isInBuyerRole ? <ClientBan /> : <CompanyBan />}
        </div>
    )
};

const mapStateToProps = (state) => {
    return {
        userRole: state.get('userRole'),
    };
};

export const BanNotification = connect(mapStateToProps)(toJS(BanNotificationView));

